import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setInquiryHistoryData,
  setWorkshopDataById,
  setUserWorkshopId,
} from "@store/inquiry/inquirySlice";
import { setFormStep } from "@store/ui/formStepSlice";

import {
  Box,
  MenuItem,
  Select,
  Typography,
  TextField,
  useMediaQuery,
  Checkbox,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Trans, useTranslation } from "react-i18next";
import "@styles/pages/Inquiry/step2/EnrollmentList.scss";

import { countriesData } from "@data/GlobalData";
import { toast } from "react-toastify";
import {
  cancelWorkshopEnrollment,
  getEnrollmentList,
  getWorkshopListById,
} from "@api/enrollmentApi";

import Popup from "reactjs-popup";
import { set } from "react-hook-form";
import AccordionRow from "@components/ui/AccordionRow";

const EnrollmentList = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const inquiryHistoryData = useSelector(
    (state) => state.inquiry.inquiryHistoryData
  );
  const inquiryLoginData = useSelector(
    (state) => state.inquiry.inquiryLoginData
  );

  const [isLoading, setIsLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const statusLabelMap = {
    "-1": t("member:cancelled"),
    0: t("member:to_attend"),
    1: t("member:attended"),
    2: t("member:attended"),

    10: t("member:waiting_list"),
  };
  const handleUpdateClick = (item) => {
    if (item.is_editable === 1) {
      console.log(item.workshop_detail_id);
      dispatch(setUserWorkshopId(item.id));
      fetchWorkshopDataById(item.workshop_detail_id);
    } else {
      toast.error(t("inquiry:popup_not_change"));
    }
  };

  const handleCancelClick = (item) => {
    if (item.is_cancel === 1) {
      setSelectedItem(item);
      setOpenPopup(true);
    } else {
      toast.error(t("inquiry:popup_cancel"));
    }
  };

  const fetchWorkshopDataById = async (workshop_detail_id) => {
    setIsLoading(true);
    try {
      const res = await getWorkshopListById({ workshop_detail_id });
      const data = res.data.Data;
      dispatch(setWorkshopDataById(data));
    } catch (err) {
      console.error(err);
      toast.error(t("inquiry:fetch_error"));
    } finally {
      setIsLoading(false);
      dispatch(setFormStep({ formKey: "inquiry", step: 2 }));
    }
  };

  const cancelEnrollment = async () => {
    const finalData = {
      id: selectedItem.id,
      email: inquiryLoginData.email,
      phone: inquiryLoginData.select + inquiryLoginData.phone,
    };

    setIsLoading(true);
    try {
      const res = await cancelWorkshopEnrollment(finalData);
      const statusCode = res.data.StatusCode;

      if (statusCode === 200) {
        toast.success(t("inquiry:cancel_success"));
        reGetEnrollmentList();
      }
    } catch (err) {
      console.error(err);
      toast.error(t("inquiry:cancel_error"));
    } finally {
      setIsLoading(false);
      setOpenPopup(false);
    }
  };

  const reGetEnrollmentList = async () => {
    const finalData = {
      lang: i18n.language,
      email: inquiryLoginData.email,
      phone: inquiryLoginData.select + inquiryLoginData.phone,
    };
    setIsLoading(true);
    try {
      const res = await getEnrollmentList(finalData);
      const data = res.data.Data;
      console.log(data);
      if (data.length === 0) {
        toast.error(t("inquiry:no_record"));
        return;
      }

      dispatch(setInquiryHistoryData(data));
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reGetEnrollmentList();
  }, []);
  return (
    <Box className="enrollment-list-container">
      <Typography className="title">
        <Trans i18nKey="inquiry:course_inquiry" />
      </Typography>
      <Typography className="maximum-three-times">
        <Trans i18nKey="inquiry:maximum_three_times" />
      </Typography>

      {inquiryHistoryData.map((item, index) => (
        <AccordionRow
          key={index}
          summaryTitle={t("inquiry:workshop_Name")}
          summaryValue={
            //   i18n.language === "hk" ? item.location_tc : item.location_en
            i18n.language === "hk" ? item.title_tc : item.title_en
          }
          summaryRight={t("inquiry:date") + ": " + item.date}
          details={[
            {
              label: t("inquiry:location"),
              value:
                i18n.language === "hk" ? item.location_tc : item.location_en,
            },
            {
              label: t("inquiry:time"),
              value: item.timeslot,
            },
            {
              label: t("inquiry:status"),
              value: (
                <Box
                  className={
                    "status-label" +
                    " " +
                    (item?.attend_status == -1
                      ? "red-status"
                      : item?.attend_status == 0
                      ? "yellow-status"
                      : item?.attend_status == 1
                      ? "green-status"
                      : item?.attend_status == 2
                      ? "green-status"
                      : item?.attend_status == 10
                      ? "orange-status"
                      : "")
                  }
                >
                  {statusLabelMap[item.attend_status]}
                </Box>
              ),
            },
            {
              label: t("inquiry:number_of_change"),
              value: item?.change_count.toString(),
            },
            {
              value: (
                <Box className="button-container">
                  <LoadingButton
                    className="loading-button"
                    sx={
                      item.is_editable == 1
                        ? {}
                        : { background: "#b2b2b2", cursor: "not-allowed" }
                    }
                    onClick={() => handleUpdateClick(item)}
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    <Trans i18nKey="inquiry:update" />
                  </LoadingButton>
                  <LoadingButton
                    className="button"
                    sx={
                      item.is_cancel == 1
                        ? {}
                        : { background: "#b2b2b2", cursor: "not-allowed" }
                    }
                    onClick={() => handleCancelClick(item)}
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    <Trans i18nKey="inquiry:cancel" />
                  </LoadingButton>
                </Box>
              ),
            },
          ]}
        />
      ))}

      {/* Popup 視窗 */}
      <Popup open={openPopup} modal onClose={() => setOpenPopup(false)}>
        {(close) => (
          <Box className="popup-container">
            <Typography className="popup-title">
              <Trans i18nKey="inquiry:popup_text" />
            </Typography>
            <Box className="popup-button-container">
              <LoadingButton
                className="button"
                onClick={() => {
                  setOpenPopup(false);
                  close();
                }}
                loading={isLoading}
                disabled={isLoading}
              >
                <Trans i18nKey="form:no" />
              </LoadingButton>{" "}
              <LoadingButton
                className="loading-button"
                onClick={cancelEnrollment}
                loading={isLoading}
                disabled={isLoading}
              >
                <Trans i18nKey="inquiry:yes" />
              </LoadingButton>
            </Box>
          </Box>
        )}
      </Popup>
    </Box>
  );
};

export default EnrollmentList;
